import React from 'react';
import { Link } from 'react-router-dom';
import tunerScreenshot from '../assets/true-lock-tuner.png';

export default function Project1() {
  return (
    <div className="project1-text">
      <div className="mx-auto pt-5 px-6">

        <h1 className="text-4xl font-bold pb-3">
          True Lock Tuner
        </h1>

        <p className="md:text-xl max-w-3xl mx-auto pb-3">
          Production iOS guitar tuning and practice application designed,
          built, shipped, and maintained for the App Store.
        </p>

        <p className="project-tech">
          Swift • SwiftUI • AVFoundation • StoreKit 2 • RevenueCat • TelemetryDeck
        </p>

            <img
          className="mx-auto mt-6 mb-8 true-lock-screenshot"
          src={tunerScreenshot}
          alt="True Lock Tuner iOS application"
        />

        <div className="p1button md:text-xl pb-10">
          <h3>
            <a
              href="https://apps.apple.com/us/app/guitar-tuner-true-lock-tuner/id6761863778"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on the App Store
            </a>
          </h3>
        </div>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Product Overview
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8">
          True Lock Tuner is a native iOS application that combines real-time
          guitar tuning, chord recognition, a configurable metronome, alternate
          tunings, and advanced practice tools in a single application. I own
          the product across design, development, testing, monetization,
          analytics, App Store deployment, and post-launch iteration.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Engineering Challenges
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-4">
          The core tuner requires continuous microphone input to be converted
          into useful, responsive feedback without creating a noisy or unstable
          user interface.
        </p>

        <p className="md:text-xl max-w-3xl mx-auto pb-8">
          The application also manages multiple interactive tools, free and Pro
          feature states, audio behavior, purchase entitlements, and
          asynchronous application workflows while maintaining a simple
          interface for the user.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          What I Built
        </h2>

        <div className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          <ul className="list-disc pl-8 space-y-3">
            <li>
              Real-time microphone-based pitch detection and tuning feedback
              using AVFoundation.
            </li>
            <li>
              Live chord recognition based on incoming audio.
            </li>
            <li>
              Configurable metronome with multiple time signatures and
              subdivisions.
            </li>
            <li>
              Tempo Trainer and Gap Click practice modes.
            </li>
            <li>
              Alternate guitar tunings and reusable tuning configuration.
            </li>
            <li>
              Free and premium application states with one-time Pro
              monetization.
            </li>
            <li>
              StoreKit purchase, entitlement, and purchase-restoration
              workflows.
            </li>
            <li>
              Privacy-focused analytics across important product workflows.
            </li>
          </ul>
        </div>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Architecture & Technical Decisions
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          The application uses state-driven SwiftUI architecture with reusable
          components and clear separation between interface state, audio
          processing, application logic, and premium feature access.
        </p>

       <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          I use asynchronous workflows where appropriate and structure features
          so that individual tools such as the tuner, metronome, chord
          recognition, and premium functionality can evolve without requiring
          large changes across the rest of the application.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Testing & Release
        </h2>

       <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          True Lock Tuner is tested in the iOS Simulator and extensively on
          physical iPhone hardware, particularly for features that depend on
          microphone input, audio behavior, StoreKit purchases, and
          device-specific interaction.
        </p>

        <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          I manage the full production release process including build
          validation, StoreKit testing, App Store Connect configuration,
          privacy disclosures, App Review submission, release management, and
          post-launch updates.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Post-Launch Development
        </h2>

     <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          The application continues to evolve after release. I use product
          analytics, testing, and real-world usage to identify improvements,
          refine existing workflows, and prioritize new features while
          maintaining the stability of the production application.
        </p>


        <div className="p1button md:text-xl pb-10">
          <h3>
            <a
              href="https://apps.apple.com/us/app/guitar-tuner-true-lock-tuner/id6761863778"
              target="_blank"
              rel="noopener noreferrer"
            >
              View True Lock Tuner on the App Store
            </a>
          </h3>

          <h3 className="pt-5">
            <Link to="/projects">
              Back to Projects
            </Link>
          </h3>
        </div>

      </div>

    </div>
  );
}

